import { RedoModal } from "@redotech/arbiter/modal/redo-modal";
import { useHandler } from "@redotech/react-util/hook";
import Star7Icon from "@redotech/redo-icons/star-07.svg";
import { memo, ReactNode } from "react";
import { useSessionExpired } from "./session-expiry-hook";

export const SessionExpirationModal = memo(function SessionExpirationModal() {
  const handleRefresh = useHandler(async () => {
    location.reload();
  });

  const isExpired = useSessionExpired();

  return (
    <RedoModal
      hideCloseButton
      isOpen={isExpired}
      modalSize="sm"
      onModalCloseRequested={() => {
        // Modal cannot be closed except via the refresh button
      }}
      primaryButton={{ text: "Refresh page", onClick: handleRefresh }}
      subtitle="Refresh your page to stay on the latest version of Redo."
      theme="success"
      title="A new version of Redo is available"
      TitleIcon={Star7Icon}
    />
  );
});

export const SessionExpirationModalProvider = memo(
  function SessionExpirationModalProvider({
    children,
  }: {
    children: ReactNode | ReactNode[];
  }) {
    return (
      <>
        {children}
        <SessionExpirationModal />
      </>
    );
  },
);
